import { apiFetch } from '@/api/client';

type MailRow = {
  status: string;
  error_message?: string | null;
  from_addr?: string | null;
  to_addrs?: string[];
};

export async function pollTestMailDelivery(
  messageId: string,
  maxWaitMs = 20_000,
): Promise<{ status: 'sent' | 'failed' | 'timeout'; error?: string }> {
  const started = Date.now();
  while (Date.now() - started < maxWaitMs) {
    const { message } = await apiFetch<{ message: MailRow }>(`/api/mail/messages/${messageId}`);
    if (message.status === 'sent') return { status: 'sent' };
    if (message.status === 'failed') {
      return { status: 'failed', error: message.error_message ?? 'Verzenden mislukt' };
    }
    await new Promise((r) => setTimeout(r, 750));
  }
  return { status: 'timeout' };
}

export function testMailDeliveryHint(toEmail: string, fromEmail: string | null): string {
  const toDomain = toEmail.split('@')[1]?.toLowerCase() ?? '';
  const fromDomain = fromEmail?.split('@')[1]?.toLowerCase() ?? '';
  if (toDomain === 'giovannipira.com' && fromDomain && fromDomain !== toDomain) {
    return ' Mail voor @giovannipira.com loopt via Mijndomein — check spam/quarantaine in webmail.mijndomein.nl.';
  }
  if (fromDomain && toDomain && fromDomain !== toDomain) {
    return ' Extern afzenderdomein: controleer spam.';
  }
  return '';
}
